import { useState, useEffect } from 'react';
import api from '../../services/api';
import { useT } from '../../i18n';

export default function AdminCompany() {
  const t = useT();
  const [enabled, setEnabled] = useState(false);
  const [maxDays, setMaxDays] = useState('0');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get('/company-settings/')
      .then((res) => {
        setEnabled(res.data.comp_time_enabled);
        setMaxDays(String(res.data.comp_time_max_days_per_user));
      })
      .catch(() => setError(t('company.error.load')))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSaved(false);
    const value = Number(maxDays);
    if (maxDays === '' || Number.isNaN(value) || value < 0) {
      setError(t('company.error.negative'));
      return;
    }
    setSubmitting(true);
    try {
      const res = await api.put('/company-settings/', {
        comp_time_enabled: enabled,
        comp_time_max_days_per_user: value,
      });
      setEnabled(res.data.comp_time_enabled);
      setMaxDays(String(res.data.comp_time_max_days_per_user));
      setSaved(true);
    } catch (err) {
      setError(err.response?.data?.detail && typeof err.response.data.detail === 'string'
        ? err.response.data.detail
        : t('company.error.save'));
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div className="spinner-border" />;

  return (
    <div>
      <h4 className="mb-4"><i className="bi bi-building-gear me-2" />{t('company.title')}</h4>
      <div className="card" style={{ maxWidth: 600 }}>
        <div className="card-body">
          <h6>{t('company.compTime.section')}</h6>
          <form onSubmit={handleSubmit}>
            <div className="form-check form-switch mb-1">
              <input className="form-check-input" type="checkbox" id="compTimeEnabled" checked={enabled}
                onChange={(e) => setEnabled(e.target.checked)} />
              <label className="form-check-label" htmlFor="compTimeEnabled">{t('company.compTime.enabled')}</label>
            </div>
            <div className="form-text mb-3">{t('company.compTime.enabledHint')}</div>
            <div className="mb-3">
              <label className="form-label" htmlFor="compTimeMax">{t('company.compTime.maxDays')}</label>
              <input id="compTimeMax" type="number" min="0" step="0.5" className="form-control" value={maxDays}
                disabled={!enabled} onChange={(e) => setMaxDays(e.target.value)} />
            </div>
            {error && <div className="alert alert-danger py-2">{error}</div>}
            {saved && <div className="alert alert-success py-2">{t('company.saved')}</div>}
            <button type="submit" className="btn btn-primary" disabled={submitting}>{t('company.save')}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
